<script setup>
import { ref, reactive } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import WithLabel from 'v3/components/Form/WithLabel.vue';

const emit = defineEmits(['confirm']);
const dialogRef = ref(null);
const form = reactive({ value: '', closed_at: '', summary: '' });

function open()  { dialogRef.value?.open(); }
function close() { dialogRef.value?.close(); }
defineExpose({ open, close });

function confirm() {
  const valueCents = Math.round((parseFloat(form.value) || 0) * 100);
  emit('confirm', {
    value_cents: valueCents > 0 ? valueCents : null,
    closed_at: form.closed_at || null,
    summary: form.summary || null,
  });
  Object.assign(form, { value: '', closed_at: '', summary: '' });
  close();
}
</script>

<template>
  <Dialog ref="dialogRef" width="md" :show-cancel-button="false" :show-confirm-button="false">
    <div class="flex flex-col gap-4">
      <div class="flex items-start gap-3">
        <span class="size-10 rounded-full bg-n-grass-3 flex items-center justify-center flex-shrink-0">
          <i class="i-lucide-trophy size-5 text-n-grass-11" />
        </span>
        <div>
          <h3 class="text-base font-medium text-n-slate-12 mb-0.5">{{ $t('PIPELINES.MOVE_TO_WON.TITLE') }}</h3>
          <p class="text-xs text-n-slate-11 mb-0">
            {{ $t('PIPELINES.MOVE_TO_WON.DESCRIPTION') }}
          </p>
        </div>
      </div>

      <div class="flex flex-col gap-3 mt-2">
        <div class="flex items-center gap-4">
          <WithLabel :label="$t('PIPELINES.MOVE_TO_WON.VALUE_LABEL')" name="value" class="flex items-center w-full [&>label]:min-w-[120px]">
            <div class="flex-1">
              <Input v-model="form.value" type="number" step="0.01" :placeholder="$t('PIPELINES.MOVE_TO_WON.VALUE_PLACEHOLDER')" />
            </div>
          </WithLabel>
        </div>
        <div class="flex items-center gap-4">
          <WithLabel :label="$t('PIPELINES.MOVE_TO_WON.DATE_LABEL')" name="closed_at" class="flex items-center w-full [&>label]:min-w-[120px]">
            <div class="flex-1">
              <Input v-model="form.closed_at" type="date" />
            </div>
          </WithLabel>
        </div>
        <div class="flex items-start gap-4">
          <label class="text-xs text-n-slate-11 min-w-[120px] pt-2">{{ $t('PIPELINES.MOVE_TO_WON.NOTE_LABEL') }}</label>
          <textarea
            v-model="form.summary"
            rows="3"
            :placeholder="$t('PIPELINES.MOVE_TO_WON.NOTE_PLACEHOLDER')"
            class="flex-1 rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 focus:outline-none focus:border-n-brand"
          />
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-2 border-t border-n-weak -mx-6 px-6 pt-4">
        <NextButton faded slate :label="$t('PIPELINES.MOVE_TO_WON.CANCEL')" @click="close" />
        <NextButton icon="i-lucide-check" :label="$t('PIPELINES.MOVE_TO_WON.CONFIRM')" @click="confirm" />
      </div>
    </div>
  </Dialog>
</template>
